export default __webpack_public_path__ + "static/media/red-close-small.ddc05922.svg";